import React, {useRef, useState} from 'react';
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';

import {
    FORM,
    MAX_NAME,
    REQUIRED,
} from "../../../components/i18n/i18n";
import {
    ButtonCancel,
    ButtonSubmit,
    GenericTableButton
} from "../../../components/buttons/buttonsActions";
import * as Yup from "yup";
import {MAX_NAME_SIZE} from "../../../components/menu-flower/constants";
import {ErrorMessage, useForm} from "react-hook-form";
import {showLoader} from "../../../components/loader/loader";
import {TT_HISTORY} from "../../../components/i18n/toolTips";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";
import {setLoading, setViewMode} from "../../../redux/actions/generalActions/mainActions";
import {resetCombos, setForm, setItem} from "../../../redux/actions/generalActions/formActions";
import {save, update} from "../../../redux/actions/promo/categoryPromotionActions";
import {connect} from "react-redux";

const CategoryPromotionFrom = (props) => {
    const { editMode, disableInputs, domainObject } = props.formProps
    const fbDataBaseId = props.mainProps?.app?.fbDataBase?.id
    const [showModal, setShowModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        code: Yup.string().required(REQUIRED).max(MAX_NAME_SIZE, MAX_NAME),
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            uid: domainObject?.uid,
            code: domainObject?.code,
            description: domainObject?.description,
        }
    });

    const onSubmit = (data, _) => {
        props.setLoading(true);
        const dataRequest = {
            noDb : false,
            allDb : false,
            fbDataBase :  { id : fbDataBaseId },
            item : {
                ...data,
                id: domainObject?.id,
            }
        };
        if (editMode) {
            let id = domainObject.id;

            props.update(id, dataRequest)
        } else {
            props.save(dataRequest)
        }
        closeForm()
    };

    const closeForm = () => {
        reset();
        props.setItem(null);
        props.setForm();
        props.onClose();
    }

    return (<>
        <Card>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
                {
                    editMode && <div className="float-right">
                        <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={showHistory}
                        />
                    </div>
                }
            </CardTitle>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md="12">
                            <FormGroup>
                                <Label>Codigo</Label>
                                <Input type="text" name="code"
                                       placeholder="Codigo"
                                       innerRef={register}
                                       disabled={disableInputs}
                                       className={(errors.code ? ' is-invalid' : '')}
                                />
                                <ErrorMessage errors={errors} name="code" component="div" className="invalid-feedback"/>
                            </FormGroup>
                        </Col>
                        <Col md="12">
                            <FormGroup>
                                <Label>Descripción</Label>
                                <Input type="text" name="description"
                                       placeholder="Descripción"
                                       innerRef={register}
                                       disabled={disableInputs}
                                       className={(errors.description ? ' is-invalid' : '')}
                                />
                                <ErrorMessage errors={errors} name="description" component="div"
                                              className="invalid-feedback"/>
                            </FormGroup>
                        </Col>
                    </Row>
                    <CardBody className="border-top">
                        <div className="float-right">
                            <ButtonSubmit/>
                            <ButtonCancel onClick={closeForm}/>
                        </div>
                    </CardBody>
                </Form>
            </CardBody>
        </Card>

        {
            showModal && <LogHistoryModal
                ref={ modalRef }
                item={ domainObject }
            />
        }
    </>)
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    formProps: state.formProps,
})

const mapActionsToProps = ({
    setViewMode,
    resetCombos,
    setItem,
    setForm,
    save,
    update,
    setLoading
})

export default connect(mapStateToProps, mapActionsToProps)(CategoryPromotionFrom)
